import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from '@/config/routes';
import { useAuth } from '@/modules/auth/useAuth';
import { beginPassportLogin, isPassportEnabled } from './passport';
import { InkHold } from './InkHold';
import { resolveHopAction, sameOriginReturnPath } from './pinAccessPolicy';

/**
 * World-switch landing. PKCE must start on this origin so Passport can
 * silently issue a code when the person already has a Passport login.
 *
 * Stays on blank ink the whole time — no keypad.
 */
export function AuthHopPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { user, loading } = useAuth();
  const started = useRef(false);

  const authenticated: boolean | undefined = loading ? undefined : user !== null;
  const returnTo = sameOriginReturnPath(params.get('return'));

  useEffect(() => {
    const action = resolveHopAction({
      authenticated,
      passportEnabled: isPassportEnabled(),
    });
    if (action === 'hold') return;
    if (action === 'home') {
      navigate(ROUTES.landing, { replace: true });
      return;
    }
    if (started.current) return;
    started.current = true;
    void beginPassportLogin(returnTo).catch(() => {
      navigate(ROUTES.landing, { replace: true });
    });
  }, [authenticated, navigate, returnTo]);

  return <InkHold />;
}
